import type { FuelSolution } from "./api";

export interface ValueDateRange {
  start: Date;
  end: Date;
}

export interface ValueMetrics {
  includedPlans: FuelSolution[];
  deliveredPlans: number;
  plansWithSavings: number;
  plansWithoutSavings: number;
  estimatedSavings: number;
}

function inRange(date: Date, range: ValueDateRange): boolean {
  return date >= range.start && date < range.end;
}

function isDelivered(solution: FuelSolution): boolean {
  return solution.status === "SENT";
}

function hasSavings(solution: FuelSolution): solution is FuelSolution & { savings: number } {
  return typeof solution.savings === "number" && Number.isFinite(solution.savings);
}

function sumEstimatedSavings(solutions: FuelSolution[]): number {
  return solutions.filter(hasSavings).reduce((total, solution) => total + solution.savings, 0);
}

export function calculateValueMetrics(
  solutions: FuelSolution[],
  range: ValueDateRange
): ValueMetrics {
  const delivered = solutions.filter((solution) => isDelivered(solution) && inRange(new Date(solution.createdAt), range));
  const estimatedSavings = sumEstimatedSavings(delivered);

  return {
    includedPlans: delivered.filter(hasSavings),
    deliveredPlans: delivered.length,
    plansWithSavings: delivered.filter(hasSavings).length,
    plansWithoutSavings: delivered.filter((solution) => !hasSavings(solution)).length,
    estimatedSavings,
  };
}
